import Stack from '@mui/material/Stack';
import Typography, { type TypographyProps } from '@mui/material/Typography';

interface TextFieldLabelProps {
  label: string;
  optional?: boolean;
  variant?: TypographyProps['variant'];
}

const TextFieldLabel = ({ label, optional, variant = 'label.field' }: TextFieldLabelProps) => (
  <Stack direction="row" gap="5px">
    <Typography variant={variant} sx={{ lineHeight: '150%' }}>
      {label}
    </Typography>
    {optional && (
      <Typography variant={variant} sx={(theme) => ({ lineHeight: '150%', color: theme.novus.textSubtle })}>
        (Optional)
      </Typography>
    )}
  </Stack>
);

export default TextFieldLabel;
